import {IChildWedlet, IElementWedlet, IS_EltWedlet, IWedlet} from "back/edit/wed/wedlets/wedlet";
import {DOM} from "lib/commons/xml/dom";
import {BoxContainer} from "back/edit/wed/wedlets/box/boxTags";

/**
 * Pour preview, n'affiche que le dernier slot non vide.
 *
 * <wed:bind eltName="x:y" wedlet="Box">
 *  <box-static>
 *    <style>...</style>
 *    <box-overlay>
 *      <div>Contenu statique si aucun contenu renseigné.</div>
 *      <wed:slot>
 *        <wed:children select="sp:sTitle"/>
 *      </wed:slot>
 *      <wed:slot>
 *        <wed:children select="sp:richTitle"/>
 *      </wed:slot>
 *    </box-overlay>
 *  </box-staic>
 * </wed:bind>
 */
export class BoxOverlay extends BoxContainer implements IElementWedlet {
	protected domObs: MutationObserver;
	protected defaultElt: Element;

	constructor() {
		super();
		this.domObs = new MutationObserver((mutations: MutationRecord[]) => {
			//console.log("mutations!!!!!!!!", mutations);
			this.refreshOverlay();
		});
	}

	configWedletElt(tpl: Element, wedlet: IWedlet) {
		super.configWedletElt(tpl, wedlet);
		this.defaultElt = (this.shadowRoot || this).firstElementChild;
		while (this.defaultElt instanceof HTMLStyleElement) this.defaultElt = this.defaultElt.nextElementSibling;
		if (this.defaultElt instanceof HTMLSlotElement) this.defaultElt = null;
	}

	onChildWedletsChange() {
		super.onChildWedletsChange();
		this.refreshOverlay();
	}

	refreshOverlay() {
		//console.log("refreshOverlay!!!!!!!!");
		//On reset les noeuds observés
		this.domObs.disconnect();

		//On cherche le dernier fils des slots non vide en partant de la fin.
		let foundNotEmty = false;
		let firstInStack: IElementWedlet;
		for (let slot = DOM.findLastChild(this.shadowRoot || this, IS_slot); slot; slot = DOM.findPreviousSibling(slot, IS_slot)) {
			const chs = slot.assignedNodes();
			for (let i = chs.length - 1; i >= 0; i--) {
				const ch = chs[i];
				if (IS_EltWedlet(ch)) {
					firstInStack = ch;
					if (foundNotEmty) {
						DOM.setHidden(ch, true);
					} else if (!(ch.wedlet as IChildWedlet).isEmpty()) {
						DOM.setHidden(ch, false);
						foundNotEmty = true;
					} else {
						DOM.setHidden(ch, true);
					}
				}
			}
		}

		//Gestion de l'affichage par défaut.
		if (this.defaultElt) {
			//On masque ou affiche le contenu statique par défaut
			DOM.setHidden(this.defaultElt, foundNotEmty);
		} else if (!foundNotEmty && firstInStack) {
			//Rien de renseigné et pas de contenu par défaut, on préserve l'affichage du 1er fils de la stack.
			DOM.setHidden(firstInStack, foundNotEmty);
		}

		//On réobserve les modifications sur les fils.
		for (let slot = DOM.findFirstChild(this.shadowRoot || this, IS_slot); slot; slot = DOM.findNextSibling(slot, IS_slot)) {
			for (const ch of slot.assignedNodes()) {
				//1ère approximation : les attributs suffisent pour détecter le switch empty / non empty (attr error et virtuals).
				//A voir si besoin d'être plus fin. Autre option : écouter les msgOt dont on serait l'ancêtre.
				if (IS_EltWedlet(ch)) this.domObs.observe(ch, {attributes: true});
			}
		}
	}
}

function IS_slot(n: Node): n is HTMLSlotElement {return n instanceof HTMLSlotElement}

//REG.reg.registerSkin('box-overlay', 1, /* language=CSS */ ``);

window.customElements.define("box-overlay", BoxOverlay);